import { Trans } from '@lingui/react/macro';
import { Button } from '@warp-ds/react';

interface LookupWizardNavigationProps {
  onSkip?: () => void;
  onNext?: () => void;
  variant: 'skip' | 'next';
  displayStep: number;
  displayTotal: number;
  isLoading?: boolean;
  navigationButtons?: boolean;
  errorMessage?: React.ReactNode;
}

export const LookupWizardNavigation = ({
  onSkip,
  onNext,
  variant,
  displayStep,
  displayTotal,
  isLoading,
  navigationButtons = true,
  errorMessage,
}: LookupWizardNavigationProps) => {
  const stepCounterClasses = navigationButtons ? 'py-12 t4 absolute left-1/2 transform -translate-x-1/2' : 'py-12 t4';
  return (
    <div className="fixed bottom-0 left-0 right-0">
      <div
        style={{
          background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 90%, #f5f5f5dd 100%)',
          height: '60px',
          pointerEvents: 'none',
          margin: '0 auto',
        }}
      />
      <div className="s-bg max-w-[710px] mx-auto">
        <div className="h-4 w-full s-bg-primary-subtle">
          <div className="h-4 s-bg-primary" style={{ width: `${(displayStep / displayTotal) * 100}%` }} />
        </div>
        {errorMessage && (
          <p className="px-16 pt-12 m-0" data-testid="lookup-error-summary" role="alert">
            {errorMessage}
          </p>
        )}
        <div className={`flex items-center relative p-16 ${!navigationButtons && 'justify-center'}`}>
          <div className={stepCounterClasses}>
            {displayStep} / {displayTotal}
          </div>
          {navigationButtons && (
            <div className="ml-auto">
              {variant === 'next' ? (
                <Button primary onClick={onNext} loading={isLoading} data-testid="next-button">
                  <Trans id="mobility-item-insertion.wizard.navigation.next">Next</Trans>
                </Button>
              ) : (
                <Button onClick={onSkip} loading={isLoading}>
                  <Trans id="mobility-item-insertion.wizard.navigation.skip">Skip</Trans>
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
